// extracted by mini-css-extract-plugin
export default {"title":"UpcomingSubscriptions-module__title--1VutM","info":"UpcomingSubscriptions-module__info--bjQqP"};